module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý user"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'new-user'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.clientTable,
    attrs: {
      "table-name": _vm.clientTable,
      "data-source": "clients",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.clientTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.clientTable].current_page - 1) * _vm.dataPaginations[_vm.clientTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tài khoản",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.id) ? _c('p', [_c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.id))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_vm._v(_vm._s(scope.row.created_at))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Thời gian đăng nhập cuối cùng"
                }
              }, [_c('span', [_vm._v(_vm._s(scope.row.updated_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', {
                staticClass: "text-grey"
              }, [(scope.row.name) ? _c('p', [_c('i', {
                staticClass: "fa fa-user",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.name))])]) : _vm._e(), _vm._v(" "), (scope.row.phone) ? _c('p', [_c('i', {
                staticClass: "fa fa-phone",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.email) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.email))])]) : _vm._e()])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Trạng thái"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', {
                staticClass: "text-center"
              }, [_c('el-tag', {
                attrs: {
                  "type": scope.row.is_online ? 'success' : 'gray'
                }
              }, [_vm._v(_vm._s(scope.row.is_online ? 'Online' :
                'Offline'))])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [(scope.row.is_online) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Offline"
                }
              }, [_c('a', {
                staticClass: "text-grey padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.toggleOffline(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa fa-wifi"
              })])]) : _vm._e(), _vm._v(" "), (!scope.row.is_online) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Online"
                }
              }, [_c('a', {
                staticClass: "text-green padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.toggleOnline(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa fa-wifi"
              })])]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deleteUser(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]), _vm._v(" "), _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Phân quyền"
                }
              }, [_c('a', {
                staticClass: "text-green padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.shieldUser(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-shield"
              })])])], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Phân quyền cho user :: ' + _vm.currentUser.name,
      "visible": _vm.shieldModal
    },
    on: {
      "update:visible": function($event) {
        _vm.shieldModal = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Quyền"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": "Chọn quyền"
    },
    model: {
      value: (_vm.admin.roles),
      callback: function($$v) {
        _vm.$set(_vm.admin, "roles", $$v)
      },
      expression: "admin.roles"
    }
  }, _vm._l((_vm.roles), function(role) {
    return _c('el-option', {
      key: role.id,
      attrs: {
        "label": role.name,
        "value": role.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addRole
    }
  }, [_vm._v("Lưu lại ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acb79b06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/User.vue
// module id = 657
// module chunks = 1